import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme as themeConfig } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 98%;
  margin-left: 10px;
  z-index: 0;
  position: relative;
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  .MuiPaper-root .MuiToolbar-regular {
    display: none;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;
export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[1200],
    },
  },
  delete: {
    color: themeConfig.status.error,
  },
  buttonActive: {
    background: themeConfig.button.primary,
    color: themeConfig.neutral.white,
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  closeModalResumeAnswer: {},
}));
